<template>
	<div class="drawer">
		<el-drawer
		size="600px"
		title="礼品卡充值"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding:20px 10%;">
				<div style="padding-bottom:10px;">
					<label style="font-size: 12px;margin-right: 10px;" slot="label" >录入礼品卡号</label>
					<el-input style="width:180px;" v-model="scanningCode" @keyup.enter.native="getGiftCardDetail" placeholder="请录入礼品卡号" size="small"></el-input>
				</div>
				<div v-for="(item,index) in giftCardTableData" :key="index" class="giftCardItem">
					<div class="giftCardItemLine">
						<span>名称：{{item.card_name}}</span>
						<span>卡号：{{item.card_number}}</span>
						<span>面额：{{item.price}}</span>
					</div>
					<div class="giftCardItemLine">
						<span>余额：{{item.surplus_money}}</span>
					</div>
				</div>
			</div>
			<div style="height: 160px;"></div>
			<el-button type="warning" style="margin:100px 10%;width:480px;position: absolute;bottom: 100px;" @click="submit">立即充值（ {{total}}元 ）</el-button>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				// 礼品卡
				scanningCode:'',
				giftCardTableData:[],
				total:0,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			// 礼品卡
			getGiftCardDetail() {
				let code = (this.scanningCode).toString().trim();
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_member+'/api/GiftCard/single', {
					cardNumber:code
				}).then(res=>{
					loading.close()
					if(res.code===0){
						if(res.data.card_type.value!=='2'){
							this.$message({
								message: '仅可录入活体卡',
								type: 'error'
							});
							return
						}
						this.giftCardTableData.push(res.data);
						let total = 0;
						for(let i=0;i<this.giftCardTableData.length;i++){
							total = this.$public.jia(total,this.giftCardTableData[i].surplus_money)
						}
						this.total = total
					}
				})
				this.$nextTick(()=>{
					this.scanningCode=''
				})
			},
			// 提交
			submit(){
				// 礼品卡
				let gift_card_list = []
				if(this.total>0){
					for(let i=0;i<this.giftCardTableData.length;i++){
						gift_card_list.push({
							"card_no": this.giftCardTableData[i].card_number,
							"card_type": this.giftCardTableData[i].card_type.title,
							"money": this.giftCardTableData[i].surplus_money
						})
					}
				}else{
					this.$message({
						message: '充值金额必须大于0',
						type: 'error'
					});
					return
				}
				let memberId = this.userInfo._id;
				let memberName = this.userInfo.basic_info.nick_name;
				let memberMobile = this.userInfo.basic_info.user_mobile;
				let params = {
					"price": this.total,
					"remark": "",
					"user_info": {
						"user_id": memberId,
						"nick_name": memberName,
						"user_mobile": memberMobile,
					},
					"gift_card_list": gift_card_list,
				}
				let loading = this.$loading()
				this.$http.post('/api/Recharge/CreateGiftCardRecharge', params).then(res=>{
					loading.close()
					if(res.code===0){
						this.$emit('submit',{type:'success'})
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			
		}
		// 礼品卡
		.giftCardItem{
			width:500px;box-shadow: 2px 2px 4px 4px #eee;border-radius: 6px;padding:10px 20px;box-sizing: border-box;margin:20px 0;
			.giftCardItemLine{
				display: flex;justify-content: space-between;line-height: 40px;
			}
		}
	}
	
</style>
